import { FC } from 'react'
import IconHouseBlue from '@/assets/icons/components/IconHouseBlue'
import IconHouseBlack from '@/assets/icons/components/IconHouseBlack'
import IconHouseWhite from '@/assets/icons/components/IconHouseWhite'

export interface IconWiggotProps {
  variant: 'white' | 'black' | 'blue'
  width?: string
  height?: string
  'data-testid'?: string
}

export const IconWiggot: FC<IconWiggotProps> = ({
  variant,
  height = '37px',
  width = '37px'
}) => {
  if (variant === 'black') {
    return <IconHouseBlack width={width} height={height} />
  }

  if (variant === 'blue') {
    return <IconHouseBlue width={width} height={height} />
  }

  return <IconHouseWhite width={width} height={height} />
}

export default IconWiggot
